import { FC } from 'react';
import { IconButton } from '../iconButton';
import minusIcon from 'assets/icons/minus.svg';

interface MinusIconButtonProps {
	onClick: () => void;
}

export const MinusButton: FC<MinusIconButtonProps> = ({ onClick }) => {
	return (
		<IconButton role="minus-button" iconSrc={minusIcon} onClick={onClick} />
	);
};
